import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { Page } from '@/components/ui/page-layout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useRequiredParams } from 'utils';
import { AccountHeader } from 'views/account/AccountHeader';
import { useAccount } from 'views/portfolio/account-queries';
import { PageSpinner } from 'widgets';

export const AccountPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { accountGUID } = useRequiredParams(['accountGUID']);
    const { isPending: isAccountLoading } = useAccount(accountGUID);

    // Define the tabs with proper routing paths
    const tabs = [
        { value: 'account-overview', label: 'Overview' },
        { value: 'allocations', label: 'Allocations' },
        { value: 'positions', label: 'Positions' },
        { value: 'lots', label: 'Lots' },
        { value: 'trades', label: 'Trades' },
        { value: 'transactions', label: 'Transactions' },
    ];

    // Get the current active tab from the URL path
    const getCurrentTab = () => {
        const pathSegments = location.pathname.split('/');

        // Look for main tab in the path segments
        for (const tab of tabs) {
            if (pathSegments.includes(tab.value)) {
                return tab.value;
            }
        }

        // Default to account-overview if no tab found
        return 'account-overview';
    };

    if (isAccountLoading) {
        return <PageSpinner />;
    }

    return (
        <Page>
            <div className="shrink-0">
                <AccountHeader />
            </div>

            <div className="flex min-h-0 flex-1 flex-col">
                <Tabs
                    value={getCurrentTab()}
                    onValueChange={(value) => navigate(value)}
                    className="flex h-full flex-col"
                >
                    <div className="flex-shrink-0 bg-white px-5 pt-3">
                        <TabsList className="flex border-gray-300">
                            <TabsTrigger value="account-overview">Overview</TabsTrigger>
                            <TabsTrigger value="allocations">Allocations</TabsTrigger>
                            <TabsTrigger value="positions">Positions</TabsTrigger>
                            <TabsTrigger value="lots">Lots</TabsTrigger>
                            <TabsTrigger value="trades">Trades</TabsTrigger>
                            <TabsTrigger value="transactions">Transactions</TabsTrigger>
                        </TabsList>
                    </div>

                    <TabsContent value={getCurrentTab()} className="min-h-0 flex-1 overflow-auto px-5 pb-6">
                        <Outlet />
                    </TabsContent>
                </Tabs>
            </div>
        </Page>
    );
};
